/* eslint-disable no-console */
import api from '~/config/httpRequest';
import * as categoriesAction from '~/store/ducks/category';
import { endLoading, startLoading } from '../ducks/loading';

export const get = () => {
  return dispatch => {
    dispatch(startLoading('isLoadingCategory'));
    api
      .get('/soluters/categories')
      .then(({ data: payload }) => {
        dispatch(
          categoriesAction.get({
            categories: payload,
          }),
        );
        dispatch(endLoading('isLoadingCategory'));
      })
      .catch(err => {
        console.error(err);
        dispatch(
          categoriesAction.get({
            categories: [],
          }),
        );
        dispatch(endLoading('isLoadingCategory'));
      });
  };
};
